export default __webpack_public_path__ + "static/media/IMDb.b287144e.svg";